import type { LoginFormProps } from '../../../../types/authForms';
import { LOGIN_MODE } from '../../../../types/enums';
import { NeobetBaseLoginForm } from './LoginForm';

const NeobetHybridLoginForm = (props: LoginFormProps) => {
  return <NeobetBaseLoginForm {...props} mode={LOGIN_MODE.USERNAME} testId='neobet-hybrid-login-form' />;
};

export default NeobetHybridLoginForm;
